import { useRef, useState } from 'react';
import { ThumbUpAltOutlined } from '@mui/icons-material';
import CommentIcon from '@mui/icons-material/Comment';
import { useTranslation } from 'react-i18next';
import { useUser } from 'src/app/hooks/useUser';
import { getAbsoluteFileUrl } from 'src/app/helpers/utils';
import { useGetAllEmojisQuery } from 'src/app/services/emojiApi';
import { useCreateUpdateDeleteReactionsMutation } from 'src/app/services/articlesUserReactionApi';
import { Tooltip } from '@mui/material';

const LikeReaction = ({ commentary = false, callback, post, handleReactionArticle }) => {
  const [createUpdateDeleteReaction] = useCreateUpdateDeleteReactionsMutation();
  const [showReactions, setShowReactions] = useState(false);
  const { user } = useUser();
  const myReaction = post.reactions?.filter((el) => el.staffId == user.staffId);
  const { data } = useGetAllEmojisQuery();
  const hoverTimeoutRef = useRef(null);
  const { t, i18n } = useTranslation('translations');
  const lang = i18n.language;

  const namesOfLikers = post?.reactions.map((el) => {
    return (
      <div className="flex items-center gap-5 text-xs">
        <span>{el.staffName}</span>
        <span>
          <img className="w-20 aspect-square" src={getAbsoluteFileUrl(el.reactionPath)} />
        </span>
      </div>
    );
  });
  const UpdateAndCreateReaction = async (reaction) => {
    if (reaction.id == (myReaction[0]?.reactionId || myReaction[0]?.id)) return;
    try {
      const data = await createUpdateDeleteReaction({
        reactionId: reaction.id,
        articleId: post.id,
        isDelete: false,
      }).unwrap();

      const { id, ...rest } = data;
      const newData = rest;
      handleReactionArticle(newData);
    } catch (error) {
      console.error('Reaction failed:', error);
    }
  };

  const handleMouseEnter = () => {
    clearTimeout(hoverTimeoutRef.current);
    hoverTimeoutRef.current = setTimeout(() => {
      setShowReactions(true);
    }, 500);
  };

  const handleMouseLeave = () => {
    clearTimeout(hoverTimeoutRef.current);
    hoverTimeoutRef.current = setTimeout(() => {
      setShowReactions(false);
    }, 500);
  };

  return (
    <div className="flex flex-col text-sm">
      <div className="flex justify-between items-center border-b p-7">
        <Tooltip title={namesOfLikers}>
          <div className="flex items-center gap-3 text-gray-600">
            <ul className="flex -space-x-3">
              {post.groupedReactions.length !== 0 &&
                post.groupedReactions.slice(0, 3).map((emoji) => (
                  <li key={emoji.reactionName}>
                    <img
                      src={getAbsoluteFileUrl(emoji?.reactionPath)}
                      alt={emoji.reactionName}
                      title={emoji.reactionName}
                      className="w-20 h-20"
                    />
                  </li>
                ))}
            </ul>
            <span>
              {post.reactionCount == 1
                ? `${post.reactionCount} ${t('Reaction')}`
                : post.reactionCount > 1
                ? `${post.reactionCount} ${t('Reactions')}`
                : null}
            </span>
          </div>
        </Tooltip>
        <div className="flex items-center gap-1 text-gray-600">
          {post.commentCount > 0
            ? `${post.commentCount}${lang === 'uz' ? 'ta' : ''} ${
                post.commentCount === 1
                  ? t('Comment')
                  : post.commentCount <= 4
                  ? t('CommentsFew')
                  : t('CommentsMany')
              }`
            : null}
        </div>
      </div>

      <div className="relative px-7 pb-0 pt-7 flex justify-between items-center">
        <div className="relative w-[80%]">
          <button
            className="flex items-center gap-3 text-gray-700 dark:text-grey-300"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            {myReaction.length > 0 ? (
              <div
                className="flex gap-5 items-center"
                onClick={() => {
                  if (myReaction[0]) {
                    let res = createUpdateDeleteReaction({
                      reactionId: myReaction[0].reactionId,
                      articleId: post.id,
                      isDelete: true,
                    }).unwrap();
                    res.then((data) => {
                      const { id, ...remain } = data;
                      handleReactionArticle(remain);
                    });
                  }
                }}
              >
                <img
                  src={getAbsoluteFileUrl(myReaction[0]?.reactionPath)}
                  alt={myReaction[0]?.reactionName}
                  className="w-32 h-32"
                />
                {/* <span className="capitalize">{myReaction[0].reactionName}</span> */}
              </div>
            ) : (
              <div
                className="flex items-center gap-5 hover:scale-90 transition-transform duration-150"
                onClick={() => {
                  UpdateAndCreateReaction(data[0]);
                }}
              >
                <ThumbUpAltOutlined fontSize="medium" />
              </div>
            )}
          </button>
          {showReactions && (
            <div
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              className="absolute -top-48 left-0 bg-white dark:bg-darkblue border px-8 py-6 rounded-full shadow-lg z-10 animate-fade-in"
            >
              <div className="flex gap-5">
                {data?.map((emoji) => (
                  <img
                    key={emoji.id}
                    src={getAbsoluteFileUrl(emoji.filePath)}
                    alt={emoji.name}
                    title={emoji.name}
                    className="w-36 aspect-square cursor-pointer hover:scale-125 transition-transform duration-150"
                    onClick={() => UpdateAndCreateReaction(emoji)}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
        {commentary && (
          <Tooltip title={t('LeaveComment')}>
            <button
              className="text-gray-700 dark:text-grey-300 hover:opacity-80 cursor-pointer flex gap-5 items-end text-xs "
              onClick={callback}
            >
              <CommentIcon fontSize="medium" />
              {/* <span className="text-xs underline text-left">{t('LeaveComment')}...</span> */}
            </button>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default LikeReaction;
